import React, { FC } from "react";
import MergeCustomersPageContent from "./MergeCustomersPageContent";
import useMergeCustomers from "./useMergeCustomers";
import { InitialCustomer } from "./types";

type MergeCustomersContainerProps = {
  initialCustomer: InitialCustomer;
  // AC19 "Cancel" — navigate back to wherever the merge screen was opened from.
  onDone: () => void;
  // AC33/34 — "View customer" on the success view navigates to the selected
  // customer's drawer.
  onViewCustomer: (selectedCustomerId: string) => void;
  // AC12 — "Wards"/"Family members" footer links navigate to the Patient drawer.
  onPatientClick: (mrn: string) => void;
  // AC37/38 — "View appointment N" links in the Conflict state, opens in a
  // new tab.
  onAppointmentClick: (appointmentId: string) => void;
};

// This container only ever mounts once the caller has real customer data
// (see MergeCustomersScreen), so the hook always starts with a valid
// initialCustomer and "isOpen" is simply "always true while mounted".
const MergeCustomersContainer: FC<MergeCustomersContainerProps> = ({
  initialCustomer,
  onDone,
  onViewCustomer,
  onPatientClick,
  onAppointmentClick,
}) => {
  const {
    customers,
    fieldSelections,
    hasAnySelfPatient,
    canSubmit,
    isSubmitting,
    mergeResult,
    errorMessage,
    blockerError,
    addCustomer,
    removeCustomer,
    setFieldSelection,
    handleSubmit,
  } = useMergeCustomers(initialCustomer, true);

  return (
    <MergeCustomersPageContent
      customers={customers}
      fieldSelections={fieldSelections}
      hasAnySelfPatient={hasAnySelfPatient}
      canSubmit={canSubmit}
      isSubmitting={isSubmitting}
      mergeResult={mergeResult}
      errorMessage={errorMessage}
      blockerError={blockerError}
      onFieldSelect={setFieldSelection}
      onAddCustomer={addCustomer}
      onRemoveCustomer={removeCustomer}
      onSubmit={handleSubmit}
      onDone={onDone}
      onViewCustomer={onViewCustomer}
      onPatientClick={onPatientClick}
      onAppointmentClick={onAppointmentClick}
    />
  );
};

export default MergeCustomersContainer;
